import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function getMailingLists() {
    return axios.get(`${SERVER_URL}/api/MailingLists`)
    .then(({ data }) => data);
}

export function createMailingList(listData) {
    return axios.post(`${SERVER_URL}/api/MailingLists`, listData)
    .then(({ data }) => data);
}

export function updateMailingList(id, newData) {
    return axios.patch(`${SERVER_URL}/api/MailingLists/${id}`, newData)
    .then(({ data }) => data);
}

export function getDefaultMailingList(agencyId) {
    const filter = {
        where: {
          agencyId,
          default: true
        },
        limit: 1
    };

    return axios.get(`${SERVER_URL}/api/MailingLists`, {
        params: { filter }
    })
    .then(({ data }) => data[0]);
}

export default { createMailingList, getMailingLists, updateMailingList, getDefaultMailingList };



// WEBPACK FOOTER //
// ./src/modules/services/mailing-list.service.js